import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-workout-phase',
  templateUrl: './workout-phase.component.html',
  styleUrls: ['./workout-phase.component.scss']
})
export class WorkoutPhaseComponent implements OnInit {
  @Input() phaseName;
  @Input() timer;
  environment = environment.baseURL;

   /* GESTIONE TIMER */
   time: number = 0; // Tempo passato
   circumference: number = 2 * Math.PI * 116; // Lunghezza totale del cerchio
   offset: number = 0; // Offset per "riempire" il cerchio (inizialmente 0, parte pieno)
   private executiontimerInterval: any;
   remainingTime: number = 0;

  constructor(public translate: TranslateService, private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.phaseName = data.phaseName;
    this.timer = data.timer;
   }

  ngOnInit() {
    console.debug('MODAL PHASE NAME',this.phaseName);
    console.debug('MODAL TIMER',this.timer)
    this.startTimer(this.timer);
  }

  closeModal() {
    this.dialogRef.close();
  }


  startTimer(maxTime: number) {
    this.executiontimerInterval = setInterval(() => {
      this.time++;

      this.remainingTime = maxTime - this.time;
      const progress = (this.time / maxTime) * 100;
      this.offset = this.circumference - (progress / 100) * this.circumference;

      if (this.time >= maxTime) {
        clearInterval(this.executiontimerInterval);
        this.closeModal();
      }
    }, 1000);
  }

  clearTimer() {
    clearInterval(this.executiontimerInterval);
    this.time = 0;
    this.remainingTime = 0;
    this.offset = this.circumference; // Ripristina l'offset al valore iniziale (cerchio pieno)
    this.closeModal();
  }

}

